import styled from 'styled-components';

import { colors, radius, spacing } from '../../tokens';

export const FieldWrapper = styled.div`
  margin-bottom: ${spacing.lg};
`;

export const GroupTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: ${colors.text};
  margin-bottom: ${spacing.md};
  padding-top: ${spacing.sm};
`;

export const FieldLabel = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  letter-spacing: 0.3px;
  color: ${colors.text};
  margin-bottom: ${spacing.sm};
`;

export const FieldNote = styled.p`
  font-size: 12px;
  line-height: 1.4;
  color: ${colors.textMuted};
  margin: ${spacing.xs} 0 0;
`;

export const GroupNote = styled(FieldNote)`
  margin: 0 0 ${spacing.md};
`;

export const Select = styled.select`
  width: 100%;
  height: 48px;
  padding: 0 ${spacing.md};
  border: 1px solid ${colors.border};
  border-radius: 2px;
  background-color: #f4f7f9;
  font-size: 14px;
  color: ${colors.text};
  outline: none;

  &:focus {
    border-color: ${colors.brand};
  }
`;

export const RadioChoices = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.sm};
`;

export const RadioChoice = styled.label<{ isSelected: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${spacing.sm};
  padding: 10px ${spacing.md};
  border: 1px solid ${({ isSelected }) => (isSelected ? colors.brand : colors.border)};
  border-radius: ${radius.medium};
  background-color: ${({ isSelected }) => (isSelected ? colors.brandSoft : colors.surface)};
  font-size: 14px;
  font-weight: ${({ isSelected }) => (isSelected ? 600 : 400)};
  line-height: 1.45;
  color: ${colors.text};
  cursor: pointer;

  &:hover {
    border-color: ${colors.brand};
  }

  &:focus-within {
    box-shadow: 0 0 0 3px ${colors.brandMedium};
  }
`;
